import { put } from "@src/appV2/api/parsedApi";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { facilityUserContract } from "@clipboard-health/contract-backend-main";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";

// Reuse the published PUT /facilityUser body schema instead of redeclaring it.
const updateAlertSettingsBodySchema = facilityUserContract.update.body;

const updateAlertSettingsResponseSchema = z.unknown();

export type UpdateFacilityUserAlertSettingsBody = z.infer<typeof updateAlertSettingsBodySchema>;

export function useUpdateFacilityUserAlertSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdateFacilityUserAlertSettingsBody) => {
      const response = await put({
        url: "/facilityUser",
        data: params,
        bodySchema: updateAlertSettingsBodySchema,
        responseSchema: updateAlertSettingsResponseSchema,
      });
      return response.data;
    },
    onSuccess: async () => {
      // Refresh the current-user query so the redesigned /my-account re-renders
      // with the saved alertSettings. Other surfaces (legacy /my-account Redux,
      // team-members list) refetch themselves via the container's `onSaved`
      // callback.
      await queryClient.invalidateQueries({ queryKey: ["/facilityUser/findByEmail"] });
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.UPDATE_HOME_HEALTH_NOTIFICATION_PREFERENCES_FAILURE,
      userErrorMessage: "Failed to update notification preferences",
    },
  });
}
